import { useEffect } from "react";
import { useLocation } from "@tanstack/react-router";

import { captureRoutePageview } from "@/lib/analytics";

export function AnalyticsRouteListener() {
  const pathname = useLocation({ select: (location) => location.pathname });

  useEffect(() => {
    captureRoutePageview(pathname);
  }, [pathname]);

  return null;
}
